import type { ComponentType } from 'svelte';
import { writable } from 'svelte/store';

const createComponentLibrary = () => {
  const componentLibraryStore = writable<Record<string, ComponentType>>({});

  function add(type: string, component: ComponentType) {
    componentLibraryStore.update((current) => {
      current[type] = component;

      return current;
    });
  }

  return {
    subscribe: componentLibraryStore.subscribe,
    add,
  };
};

export const componentLibrary = createComponentLibrary();
